import { SvgIcon, SvgIconProps } from "@mui/material";

export const H1Icon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M5 6v12M13 6v12M5 12h8M18.5 18v-5l-1.25 1.25M20 18h-3"
      />
    </svg>
  </SvgIcon>
);
